module.exports = __webpack_public_path__ + "static/media/wizualizacja-87.0c0cec33.png";